import {
    BackContainer,
    Container,
    Icon,
    Title,
    TitlesContainer,
    SubTitle,
    PaginationContainer,
    PaginationBorder,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/InvitationStatusScreen/InvitationStatusScreen.styled";
import InvitationsList from "app/pages/digital-suite/home-page/components/Rewards/screens/InvitationStatusScreen/InvitationsList/InvitationsList";
import { usePagination } from "app/custom-hooks/usePagination";
import { INVITATIONS_PER_PAGE } from "app/pages/digital-suite/home-page/components/Rewards/utils/consts";
import type { IInvitation } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";

interface IInvitationStatusScreenProps {
    onBackClick: VoidFunction;
    invitationsList: IInvitation[];
    invitationCount: number;
    hasPagination: boolean;
}

const InvitationStatusScreen = ({
    onBackClick,
    invitationsList,
    invitationCount,
    hasPagination,
}: IInvitationStatusScreenProps) => {
    const i18n = i18nFilter();
    const [pageItems, paginationComponent] = usePagination({
        itemsPerPage: INVITATIONS_PER_PAGE,
        listItemsLength: invitationCount,
    });

    const { from, to } = pageItems;
    const currentPageInvitations = invitationsList.slice(from, to);

    return (
        <>
            <BackContainer onClick={onBackClick}>
                <Icon
                    iconName="arrow-left"
                    size="xs"
                />
                {i18n("rewards_modal.invitation_screen.back_button")}
            </BackContainer>
            <Container>
                <TitlesContainer>
                    <Title>{i18n("rewards_modal.invitation_screen.title")}</Title>
                    <SubTitle>{i18n("rewards_modal.invitation_screen.subtitle")}</SubTitle>
                </TitlesContainer>
                <InvitationsList invitationsList={currentPageInvitations} />
                {hasPagination ? (
                    <>
                        <PaginationBorder />
                        <PaginationContainer>{paginationComponent}</PaginationContainer>
                    </>
                ) : null}
            </Container>
        </>
    );
};

export default InvitationStatusScreen;
